import {
	get,
	post
} from './http' // 导入模块

/* 1
获取头像框
*/
export const getAllLocations = params => post('/api/Location/getalllocations', params);

/* 2
获取学历    ---下拉框选项
*/
export const httpGetEduLevel = params => get('/api/EducationLevel/geteducationlevel', params);

/* 3
获取行业选择器数据
*/
export const httpGetIndustryJson = params => post('/api/Industry/getallindustries', params);

/* 3
获取所有职业数据
*/
export const httpGetOccupationJson = params => post('/api/Occupation/getalloccupation', params);

/* 5
更新行家服务状态接口
*/
export const httpUpdateServicesStatus = params => post('/api/ExpertUser/updateservicesstatus', params);

/* 6
更新行家服务费用接口
*/
export const httpUpdateServiceCost = params => post('/api/ExpertUser/updateservicecost', params);

/* 7
编辑提交后返回的状态
*/
export const httpGetauthStatus = params => post('/api/ExpertUser/getauthstatus/' + params['id'], params);

/* 8
编辑提交后fuwuxiangmu
*/
export const httpGetServiceitem = params => post('/api/ExpertUser/getserviceitem/' + params['id'], params);

/* 7
编辑提交后返回的状态
*/
export const httpGetserviceStatus = params => post('/api/ExpertUser/getservicestatus/' + params['id'], params);

/* 8
	获取行家名片信息
*/
export const httpExpertInfoGet = params => post('/api/ExpertUser/getexpertcardinfo/' + params);

/* 9
	获取行家二维码
*/
//export const httpExpertQrcodeGet = params => get('/api/ExpertUser/qrcode' + params);

export const httpExpertQrcodeGet = params => post('https://jianyou.risfond.com/api/ExpertUser/GetExpertUserQrCode', params);


// WEBPACK FOOTER //
// ./src/api/common.js